











import { Vue, Component } from 'vue-property-decorator';
import CamaraEnVivo from '@/pantallas/Camaras/EnVivo/CamaraEnVivo.vue';
import CamaraEnVivoOperaciones from '@/pantallas/Camaras/EnVivo/CamaraEnVivoOperaciones.vue';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';

@Component({
  components: { CamaraEnVivo, CamaraEnVivoOperaciones },
})
export default class CamaraEnVivoOperacionesPantalla extends Vue {

}
